<template>
  <div class="kf-action-panel">


    <!-- 特殊任务处理 -->
    <div v-if="specTaskTypes && specTaskTypes.includes('KF_UPDATE_LOCATION')">
      <div class="update-location-row">
        <div class="action-title">输入上车点地址：</div>
        <el-input v-model="updateLocationAddressText" readonly placeholder="点击选择地址" size="small"
          class="select-address-input" @click.native="openUpdateLocationSelectMap">
          <el-button slot="append" icon="el-icon-map-location" />
        </el-input>
      </div>
    </div>

    <!-- 选择答案 -->
    <div v-if="commonTaskTypes.includes('CHOICE_OPTION') && choices && choices.length > 0" class="action-section">
      <div class="action-title">请选择：</div>
      <div class="choice-list">
        <div v-for="(choice, choiceIndex) in choices" :key="choiceIndex" class="choice-item"
          :class="{ 'choice-selected': selectedChoice && selectedChoice.value === choice.value }"
          @click="handleChoiceSelect(choice)">
          <i class="el-icon-check" v-if="selectedChoice && selectedChoice.value === choice.value"></i>
          <span>{{ choice.text }}</span>
        </div>
      </div>
    </div>

    <!-- 自由回复 -->
    <div v-if="commonTaskTypes.includes('FREE_REPLY')" class="action-section reply-section">
      <!-- 切换按钮 -->
      <div class="mode-switch">
        <el-button-group>
          <el-button size="small" :type="activeMode === 'text' ? 'primary' : ''" @click="activeMode = 'text'">
            <i class="el-icon-edit"></i>
            文字输入
          </el-button>
          <el-button size="small" :type="activeMode === 'image' ? 'primary' : ''" @click="activeMode = 'image'">
            <i class="el-icon-picture"></i>
            图片上传
          </el-button>
        </el-button-group>
      </div>

      <!-- 内容区域（共用区域） -->
      <div class="reply-content-wrapper">
        <!-- 文字输入区域 -->
        <div v-show="activeMode === 'text'" class="content-area">
          <el-input v-model="replyContent" type="textarea" :rows="5" placeholder="请输入回复内容（可选）" maxlength="500"
            show-word-limit class="reply-input"></el-input>
        </div>

        <!-- 图片上传区域 -->
        <div v-show="activeMode === 'image'" class="content-area">
          <multiple-file-upload v-model="photos" :filePath="$ossPath.orderProblemChat()" :limit="9"
            upload-tip="支持上传图片，单个文件大小不超过20MB，最多9张" />
        </div>
      </div>
    </div>

    <!-- 统一的操作按钮区域 -->
    <div class="action-buttons">
      <div class="button-left">
        <el-button v-if="showNotifyButton" type="warning" size="small" plain @click="handleNotify">
          <i class="el-icon-bell"></i>
          收到提醒
        </el-button>
      </div>
      <div class="button-right">
        <el-button v-if="specTaskTypes && specTaskTypes.includes('KF_UPDATE_LOCATION')" type="primary" size="small"
          @click="handleSubmitUpdateLocation" :disabled="!updateLocationAddress">
          提交上车点
        </el-button>

        <el-button v-if="commonTaskTypes && commonTaskTypes.includes('CHOICE_OPTION')" type="primary" size="small"
          @click="handleSubmitChoice" :disabled="!selectedChoice">
          提交选择
        </el-button>
        <el-button v-if="commonTaskTypes && commonTaskTypes.includes('FREE_REPLY')" type="primary" size="small"
          @click="handleSubmitReply"
          :disabled="(!replyContent || replyContent.trim() === '') && (!photos || photos.length === 0)">
          提交回复
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import MultipleFileUpload from "@/components/MultipleFileUpload";
import { kfReply, updateKfHandlingStatus } from "@/api/problem";
import { SHOW_LOCATION_SELECT_MAP } from "@/core/const/global-event";
import { BaseDataService } from "@/service";

export default {
  name: "KfActionPanel",
  components: {
    MultipleFileUpload
  },
  props: {
    // 当前处理结果
    handleResult: {
      type: Object,
      default: () => ({})
    },
    // 问题
    orderProblem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      photos: [],
      replyContent: "",
      selectedChoice: null, // 选中的选择项
      activeMode: "text", // 当前显示模式：'text' 文字输入，'image' 图片上传
      updateLocationAddress: null, // { name, lng, lat }
    };
  },
  computed: {

    // 获取允许的公共任务类型（选择/自由回复等）
    commonTaskTypes() {
      if (!this.handleResult || !this.handleResult.nextAllowedComTasks) {
        return [];
      }
      return this.handleResult.nextAllowedComTasks || [];
    },

    // 获取允许的特定任务类型（更新上车点等）
    specTaskTypes() {
      if (!this.handleResult || !this.handleResult.nextAllowedSpecTasks) {
        return [];
      }
      return this.handleResult.nextAllowedSpecTasks || [];
    },

    // 获取选择项列表
    choices() {
      return this.handleResult.choices || [];
    },
    // 是否显示收到通知按钮
    showNotifyButton() {
      return (
        this.handleResult &&
        this.handleResult.dealRole === "KF" &&
        this.orderProblem.status === "SYS_HANDLING"
      );
    },

    updateLocationAddressText() {
      return (this.updateLocationAddress && this.updateLocationAddress.name) || "";
    }
  },
  watch: {
    handleResult: {
      handler() {
        // 当处理结果变化时，重置表单
        this.resetForm();
      },
      deep: true
    }
  },
  methods: {
    // 重置表单
    resetForm() {
      this.photos = [];
      this.replyContent = "";
      this.selectedChoice = null;
      this.activeMode = "text";
      this.updateLocationAddress = null;
    },



    // 直接复用全局的 locationSelectMap（area 留空给你后续填）
    openUpdateLocationSelectMap() {

      const { order } = this.orderProblem;
      const { depLatitude, depLongitude, departure, pathId } = order;
      const point = this.updateLocationAddress
        ? {
          lat: +this.updateLocationAddress.lat,
          lng: +this.updateLocationAddress.lng,
          name: this.updateLocationAddress.name
        }
        : {
          lat: +depLatitude,
          lng: +depLongitude,
          name: departure
        };


      const area = BaseDataService.getRouteAreaByPathId(pathId, true);

      this.$bus.$emit(SHOW_LOCATION_SELECT_MAP, point, area, ({ lat, lng, name }) => {
        this.updateLocationAddress = {
          lat: `${lat}`,
          lng: `${lng}`,
          name: name || ""
        };
      });
    },
    // 处理收到通知
    handleNotify() {
      updateKfHandlingStatus(this.orderProblem.id).then((res) => {
        this.$emit("success", res.data || {});
      });
    },
    // 选择答案（只选择，不提交）
    handleChoiceSelect(choice) {
      // 如果点击的是已选中的项，则取消选择
      if (this.selectedChoice && this.selectedChoice.value === choice.value) {
        this.selectedChoice = null;
      } else {
        this.selectedChoice = choice;
      }
    },
    // 提交选择
    handleSubmitChoice() {
      if (!this.selectedChoice) {
        this.$message.warning("请先选择一个答案");
        return;
      }

      const choice = this.selectedChoice;

      // 如果有确认文本，先确认
      if (choice.confirmText) {
        this.$confirm(choice.confirmText, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.submitChoice(choice);
          })
          .catch(() => { });
      } else {
        this.submitChoice(choice);
      }
    },
    // 提交选择到后端
    submitChoice(choice) {
      const param = {
        problemId: this.orderProblem.id,
        content: choice.value,
        handleMsgId: this.handleResult.handleMsgId,
        replyType: 'CHOICE_OPTION'
      };

      kfReply(param).then((res) => {
        this.$emit("success", res.data || {});
        this.resetForm();
      });
    },
    // 提交回复（支持文字和图片）
    handleSubmitReply() {
      const content = this.replyContent ? this.replyContent.trim() : "";
      const imageUrls = Array.isArray(this.photos) ? this.photos.map((file) => file.url) : [];

      // 至少需要文字或图片中的一种
      if (!content && imageUrls.length === 0) {
        this.$message.warning("请输入回复内容或上传图片");
        return;
      }

      const param = {
        problemId: this.orderProblem.id,
        content,
        photos: imageUrls,
        handleMsgId: this.handleResult.handleMsgId,
        replyType: 'FREE_REPLY'
      };

      kfReply(param).then((res) => {
        this.$emit("success", res.data || {});
        this.resetForm();
      });
    },
    // 提交更新上车点位置（KF_UPDATE_LOCATION）
    handleSubmitUpdateLocation() {
      if (!this.updateLocationAddress) {
        this.$message.warning("请先选择上车点地址");
        return;
      }


      const param = {
        problemId: this.orderProblem.id,
        taskType: "KF_UPDATE_LOCATION",
        content: "获取到乘客最新定位，点击按钮可直接导航",
        handleMsgId: this.handleResult.handleMsgId,
        position: {
          lng: `${this.updateLocationAddress.lng}`,
          lat: `${this.updateLocationAddress.lat}`,
          name: this.updateLocationAddress.name,
        }
      };

      kfReply(param).then((res) => {
        this.$emit("success", res.data || {});
        this.resetForm();
      });
    }
  }
};
</script>

<style scoped lang="less">
.kf-action-panel {
  margin-top: 12px;
  padding: 12px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

.action-section {
  margin-bottom: 12px;

  .action-title {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 8px;
  }
}

.choice-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.choice-item {
  padding: 10px 14px;
  background-color: #f0f2f5;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  border: 1px solid transparent;

  &:hover {
    background-color: #e4e7ed;
    border-color: #c0c4cc;
  }

  &.choice-selected {
    background-color: #ecf5ff;
    border-color: #409eff;
    color: #409eff;
  }

  i {
    margin-right: 8px;
    color: #409eff;
    font-weight: bold;
  }

  span {
    flex: 1;
  }
}

.reply-section {
  .mode-switch {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
  }

  .reply-content-wrapper {
    position: relative;
    min-height: 120px;
  }

  .content-area {
    .reply-input {
      /deep/ .el-textarea__inner {
        padding: 8px 12px;
        font-size: 13px;
        line-height: 1.5;
      }
    }
  }
}

.update-location-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-bottom: 8px;

  .action-title {
    margin-bottom: 0;
    color: #303133;
  }

  .select-address-input {
    flex: 1;
    min-width: 420px;
    cursor: pointer;

    ::v-deep .el-input__inner {
      cursor: pointer;
    }
  }
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e4e7ed;

  .button-left {
    flex: 1;
  }

  .button-right {
    flex-shrink: 0;
  }
}
</style>
